import { CallbackObject } from 'api/core/get-page-function';
import { GetServersVm } from './get-servers.vm';
import { AxiosResponse } from 'axios';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';

export const getServers = async (offset: string, callback: CallbackObject<GetServersVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/asrs/servers`, config);
    callback.success(plainToClass(GetServersVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
